import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgVk = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-vk';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.096 7.058c-.134.03-.341.104-.46.164-.23.116-.556.364-.556.423 0 .019.086.035.192.035.258 0 .567.156.706.357.196.283.216.428.243 1.812.025 1.23.022 1.298-.052 1.43-.098.175-.365.321-.589.321-.276 0-.463-.135-.804-.58a17.4 17.4 0 0 1-1.753-2.811c-.255-.504-.33-.62-.454-.697L6.42 7.42H4.86c-1.436 0-1.568.006-1.666.072-.162.11-.216.276-.156.477.08.268.769 1.601 1.182 2.287 1.805 3 3.904 5.078 5.82 5.763.652.233.893.267 2.1.289 1.217.023 1.366.006 1.584-.177.203-.172.236-.301.236-.94 0-.502.01-.587.081-.703.155-.254.596-.363.881-.217.076.04.624.474 1.218.966.594.493 1.161.933 1.26.979.174.081.239.084 1.82.084 1.473 0 1.664-.007 1.876-.073.26-.08.444-.235.488-.41.041-.16-.048-.448-.194-.636-.069-.089-.674-.665-1.344-1.281-.671-.616-1.273-1.187-1.339-1.27a.75.75 0 0 1-.096-.711c.033-.077.571-.733 1.196-1.459 1.16-1.347 1.375-1.624 1.593-2.053.232-.458.203-.756-.09-.916-.119-.065-.282-.071-1.91-.071h-1.78l-.147.091c-.12.075-.32.375-1.1 1.655-.524.86-1.052 1.682-1.174 1.828-.378.452-.781.623-1 .425s-.217-.188-.239-2.019c-.019-1.644-.023-1.705-.106-1.86-.113-.209-.231-.316-.474-.428-.196-.09-.231-.092-1.62-.1-1.069-.006-1.48.006-1.664.046"
    })
  }));
});
export default SvgVk;